import _slicedToArray from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// ignore-string-externalization
import React from 'react';
import { makeContentfulAsset } from '../Contentful';
import { isContentfulImage } from '../utils';
import { ContentfulImage, lightCaptionStyle } from '../Contentful/ContentfulImage';
import { DefaultRenderer } from './DefaultRenderer';
import { VideoComponent } from '../ui/Video';
import { renderToString } from 'react-dom/server';
import { maxWidth } from '../Module/ArticleModule/styleConstants';
import styled from 'styled-components';
import { display1FontSize, display1FontWeight, spacer4, spacer8, spacer80 } from '@spotify-internal/encore-web';
import { jsx as _jsx } from "react/jsx-runtime";
var dropCapStyle = "\n  padding-left: ".concat(spacer4, ";\n  padding-bottom: 0px;\n  padding-right: ").concat(spacer8, ";\n  float: left;\n  position: relative;\n  top: ").concat(spacer4, ";\n  margin-bottom: ").concat(spacer4, ";\n  margin-left: ").concat(spacer8, ";\n  margin-right: ").concat(spacer4, ";\n  font-size: ").concat(display1FontSize, ";\n  line-height: ").concat(spacer80, ";\n  font-weight: ").concat(display1FontWeight, ";\n");
var DropCap = styled.p.withConfig({
  displayName: "ArticleRenderer__DropCap",
  componentId: "kon8yq-0"
})(["max-width:", ";margin:auto;&:first-letter{", "}"], maxWidth, dropCapStyle);
export var ArticleRenderer = /*#__PURE__*/function (_DefaultRenderer) {
  _inherits(ArticleRenderer, _DefaultRenderer);

  var _super = _createSuper(ArticleRenderer);

  function ArticleRenderer() {
    var _this;

    _classCallCheck(this, ArticleRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "pNum", 0);

    _defineProperty(_assertThisInitialized(_this), "initialDropcap", false);

    return _this;
  }

  _createClass(ArticleRenderer, [{
    key: "image",
    value: function image(href, title, text) {
      var fullWidth = (text || '').indexOf('full-width') > -1; // contentful image: display as natural-width responsive asset

      var isContentfulImg = isContentfulImage(href);

      if (isContentfulImg && !fullWidth) {
        var bits = href.split('.');
        var contentType = "image/".concat(bits[bits.length - 1].replace('jpg', 'jpeg'));
        var asset = makeContentfulAsset({
          url: href,
          contentType: contentType,
          description: title || text
        }); // TODO: unhack caption styling

        return renderToString( /*#__PURE__*/_jsx(ContentfulImage, {
          asset: asset,
          caption: text,
          captionStyle: lightCaptionStyle
        }));
      }

      var txt = (text || '').replace('full-width', '');

      var image = /*#__PURE__*/_jsx("img", {
        src: href,
        alt: title
      });

      return "\n      <figure>\n        ".concat(image, "\n        ").concat(renderToString( /*#__PURE__*/_jsx("figcaption", {
        style: lightCaptionStyle,
        children: txt
      })), "\n      </figure>\n    ");
    }
  }, {
    key: "paragraph",
    value: function paragraph(text) {
      if (text && !text.startsWith('[')) {
        this.pNum++;
      }

      var renderedText = text; // check if dropcap needed/requested

      if (text && text.length > 1 && (text.startsWith('^') || this.pNum === 1 && this.initialDropcap && /^[a-zA-Z\"]/.test(text))) {
        renderedText = renderToString( /*#__PURE__*/_jsx(DropCap, {
          dangerouslySetInnerHTML: {
            __html: text.replace(/^\^/, '')
          }
        }));
      }

      return _get(_getPrototypeOf(ArticleRenderer.prototype), "paragraph", this)(renderYoutubeVideoParagraph(renderedText));
    }
  }]);

  return ArticleRenderer;
}(DefaultRenderer);
/**
 * Renders a YouTube video iframe
 *
 * @example: [youtube-video nBu0rl5B70I]
 */

export var renderYoutubeVideoParagraph = function renderYoutubeVideoParagraph(text) {
  var isVideo = text.indexOf('[youtube-video') === 0;

  if (!isVideo) {
    return text;
  }

  var fullWidth = text.indexOf('[youtube-video-full') === 0;
  var url = getVideoUrl(text);

  if (url) {
    return renderToString( /*#__PURE__*/_jsx(VideoComponent, {
      url: url,
      wrapperStyle: fullWidth ? {
        maxWidth: 'unset'
      } : {},
      iframeStyle: fullWidth ? {
        maxWidth: 'unset'
      } : {}
    }));
  }

  return '';
};

function getVideoUrl(text) {
  try {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    var _ref = /\[(youtube-video|youtube-video-full)\s+([\w-_]+)?\]/gi.exec(text),
        _ref2 = _slicedToArray(_ref, 3),
        videoId = _ref2[2];

    return "https://www.youtube.com/embed/".concat(videoId, "?iv_load_policy=3&playsinline=1&rel=0");
  } catch (e) {
    // don't error out if we can't parse the YouTube ID
    console.error(e); // eslint-disable-line no-console

    return '';
  }
}